import React from 'react';
import InputField from './InputField';

const NameField = ({ field }) => {
  // You can customize this to fit your needs
  const firstName = field.inputs.find(input => input.key === 'first');
  const lastName = field.inputs.find(input => input.key === 'last');

  return (
    <>
      {firstName && <InputField field={firstName} />}
      {lastName && <InputField field={lastName} />}
    </>
  );
};

export default NameField;